import { AcademicLevel, Campus, Email, FirstName, LastName, MobilePhoneRequired, Consentement } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  consent: Yup.object().shape({
    ...Consentement
  }),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired
  })
})

export default schema
